import { ScheduleWeekDay } from '../types/backendTypes/ScheduleWeekDay';
import { ScheduleWeekDaySwedish } from '../types/ScheduleWeekDaySwedish';

export const translateDayToEnglish = (dayInSwedish: string) => {
  switch (dayInSwedish) {
    case ScheduleWeekDaySwedish.Monday:
      return ScheduleWeekDay.Monday;
    case ScheduleWeekDaySwedish.Tuesday:
      return ScheduleWeekDay.Tuesday;
    case ScheduleWeekDaySwedish.Wednesday:
      return ScheduleWeekDay.Wednesday;
    case ScheduleWeekDaySwedish.Thursday:
      return ScheduleWeekDay.Thursday;
    case ScheduleWeekDaySwedish.Friday:
      return ScheduleWeekDay.Friday;
    case ScheduleWeekDaySwedish.Saturday:
      return ScheduleWeekDay.Saturday;
    case ScheduleWeekDaySwedish.Sunday:
      return ScheduleWeekDay.Sunday;
  }
};
